import styled from 'styled-components';

const Divider = styled.div`
  border-top: 1px solid #cccccc;
  width: 100%;
`;

const DividerWrapper = styled.div`
  margin: 0 auto;
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  padding: ${props => (props.padding ? props.padding : '1em 0')};
  text-align: center;
`;

export { Divider, DividerWrapper };
